<template>
    <div class="check">
        <div class="warning">
            <p>
                ИНН компании заявителя не совпадает ни с одним из действующих
                сертификатов. Пожалуйста, добавьте действующий сертификат и
                перезагрузите страницу
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>